import { ModelBase } from 'store/model-base';

export class E911AddressStatus extends ModelBase {
    public static storeName: string = 'e911AddressStatus';

    public requestId: RequestId;
    public status: string; // e.g., 'IN_PROGRESS', 'CANCELLED', 'FAILED', 'SUCCESS'
}
